/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

function Table4({ setFieldValue }) {
  const [data, setData] = useState({
    muc1: [
      {
        id: uuidV4(),
        value2: "Số thuế phải nộp của dịch vụ viễn thông cước trả sau",
        value3: "[06]",
        value4: 0,
      }
    ],
    muc2: [
      {
        id: uuidV4(),
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: 0,
        value9: 0,
        value10: 0,
        value11: 0,
      },
    ],
    muc3: {
      id: uuidV4(),
      value2: "Cộng theo từng tỉnh",
      value3: "[18]",
    },
    muc4: {
      id: uuidV4(),
      value2: 1,
      value3: 0,
    },
    muc5: [
      {
        id: uuidV4(),
        value2: "Cộng các tỉnh",
        value3: "[19]",
        value4: 0,
      },
      {
        id: uuidV4(),
        value2:
          "Số thuế phải nộp cho nơi NNT đóng trụ sở chính ([20]=[06]-[19] hoặc [24]=[06]-[23])",
        value3: "[20]",
        value4: 0,
      },
    ],
  });

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleChangeValue = (type, id, name, value) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: 0,
      value9: 0,
      value10: 0,
      value11: 0,
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box style={{ maxWidth: "100%" }}>
        <table style={tableStyle}>
          <tbody>
            {data.muc1.map((item, index) => (
              <tr key={index}>
                <Td style={{ background: "#f8f8f8" }} colSpan="9">
                  {item.value2}
                </Td>
                <Td style={{ textAlign: "right", background: "#f8f8f8" }}>{item.value3}</Td>
                <Td style={{ textAlign: "right" }}>
                  <InputTable
                    type="number"
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
              </tr>
            ))}
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Mã số thuế/ Mã địa điểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Địa bàn hoạt động, sản xuất kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Cơ quan thuế quản lý địa bàn nhận phân bổ
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="3">
                Doanh thu dịch vụ viễn thông cước trả sau (chưa có thuế giá trị gia tăng)
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                {
                  "Số thuế phải nộp cho từng tỉnh nơi có đơn vị phụ thuộc kinh doanh dịch vụ viễn thông cước trả sau"
                }
              </Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tỉnh</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Huyện</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Cơ quan thuế cấp Cục</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Cơ quan thuế trực tiếp quản lý
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Hàng hoá chịu thuế xuất 5%
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Hàng hoá chịu thuế xuất 10%
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tổng</Th>
            </tr>
            <tr style={{background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} className="toggle-button">
                [08]{" "}
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc2")}>
                    Thêm dòng
                  </button>
                </div>
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>[09]</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>[10]</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>[12]</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>[11]</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                [13]
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>[14]</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>[15]</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>[16]=[14]+[15]</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>[17]=1%x[14]+2%x[15]</Th>
            </tr>

            {data.muc2.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "right" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc2", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <InputTable
                    type="text"
                    name="value2"
                    value={item.value2}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc2"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    type="text"
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc2"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc2", item.id, "value4", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc2", item.id, "value5", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc2", item.id, "value6", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc2", item.id, "value7", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ background: "#ddeff3"}}>
                  {item.value8}
                </Td>
                <Td style={{ textAlign: "right", }}>
                  <InputTable
                    type="number"
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc2"
                  />
                </Td>
                <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                  {item.value10}
                </Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>
                  {item.value11}
                </Td>
              </tr>
            ))}
            <tr>
              <Td style={{ textAlign: "left", fontWeight: "bold", background: "#ddeff3" }}></Td>
              <Td
                style={{ textAlign: "left", fontWeight: "bold", background: "#ddeff3" }}
                colSpan="8"
              >
                {data.muc3.value2}
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {data.muc3.value3}
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>{data.muc4.value2}  </Td>
              <Td style={{ textAlign: "left", background: "#ddeff3" }} colSpan="9"></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>{data.muc4.value3}</Td>
            </tr>
            {data.muc5.map((item, index) => (
              <tr key={index}>
              <Td style={{ textAlign: "left", background: "#ddeff3", fontWeight: "bold"  }} colSpan="9">{item.value2}</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>{item.value3}</Td>

              <Td style={{ textAlign: "right", background: "#ddeff3" }}>{item.value4}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(Table4);

function InputTable(props) {
  const { onChange, type = "text", name, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id, rowType });
    } else if (type === "date") {
      onChange({ value, name, type, id, rowType });
    } else if (type == "decimal") {
      if (!regexDecimal.test(value)) return;
      onChange({ value, name, id, rowType });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id, rowType });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      name={name}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
